import { useAuthStore } from '@/stores/auth';
import { hasPermission, type Permission } from '@valiosascrm/shared';

export function useCanAccess(permission: Permission): boolean {
  const user = useAuthStore((state) => state.user);
  if (!user) return false;
  return hasPermission(user.role, permission);
}
